import { createAction, props } from '@ngrx/store';

import { FeedNavigateActionPayload } from '../../interfaces/navigate-payload';

/** News feed navigate action */
export const navigate = createAction(
  '[News Feed] Navigate',
  props<{ data: FeedNavigateActionPayload }>(),
);
